import Box from 'UIKit/Box/Box'
import OpenEffect from 'UIKit/OpenEffect'
import { MENU_ITEMS } from 'config/constants/menu'
import useActivePage from 'hooks/useActivePage'
import styled from 'styled-components'
import ExtendMenu from './ExtendMenu'
import LanguageSelect from './LanguageSelect'
import MenuItem from './MenuItem'
import HunnyPlayAppMenu from './component/HunnyPlayAppMenu'

const StyledContainer = styled(OpenEffect)`
  width: 100%;
  min-width: ${({ theme }) => theme.navigationWidth}px;
  padding: 12px;
  height: 100%;
  overflow-y: auto;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: ${({ theme }) => theme.navigationWidth}px;
  }
`

const StyledMenuContainer = styled(Box)`
  margin-top: 18px;
  padding-bottom: 40px;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding-bottom: 12px;
  }
`

const StyledWrapLanguage = styled(Box)`
  margin-top: 4px;
  height: 48px;

  #language-selected {
    padding-inline: 12px;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    display: none;
  }
`

const MenuContent = ({ small }) => {
  const { activeMenuItem } = useActivePage()

  return (
    <StyledContainer>
      <ExtendMenu />

      <StyledMenuContainer>
        {MENU_ITEMS.map((item) => {
          return (
            <MenuItem
              id={item.id}
              key={item.route}
              small={!!small}
              item={item}
              activeRoute={activeMenuItem?.route}
              attributes={item?.attributes || {}}
            />
          )
        })}
        <HunnyPlayAppMenu />
        <StyledWrapLanguage>
          <LanguageSelect small={false} />
        </StyledWrapLanguage>
      </StyledMenuContainer>
    </StyledContainer>
  )
}

export default MenuContent
